import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('benefits_set_field_history',
  '/benefits_set_field_histories',
  'history')
const actions = generator.generate()

export default actions
